<template>
  <div id="cancelar-fechamento-pedido">

    <nav-menu></nav-menu>

    <div class="w3-container">

      <exibir-processando v-if="processando"/>

      <header>
        <h5 class="w3-left w3-col s12 l12" style="margin-top:30px;">
          <b>
            <i class="fas fa-reply"></i>
            <span> Cancelar fechamento de pedidos</span>
          </b>
        </h5>
      </header>

      <div class="titulo-grid">
        <h5 class="titulo texto-vermelho w3-col s12 w3-margin-top" v-cloak>
          <i class="fa fa-shopping-cart cor-icone-pedido"></i>
          <span>Pedidos</span>
        </h5>
      </div>

      <div
        style="text-align:right; margin-bottom: 35px;"
        class="w3-center texto-cinza w3-display-container w3-col s12 m12 w3-padding-24"
        v-cloak>

        <button
          class="w3-button w3-theme w3-col s12 m2 w3-display-middle w3-margin-top"
          v-on:click="buscarPedidos()"
          :disabled="processando">
          <span>Processar</span>
        </button>
      </div>

      <div class="w3-mobile" v-show="pedidos.length > 0" id="tabelaPedidos">
        <table :class="
          'w3-table w3-border w3-bordered w3-striped w3-white w3-margin-top ' + 
          'w3-margin-bottom w3-hide-small'">

          <thead>
            <tr>
              <th>Pedido</th>
              <th>Data pedido</th>
              <th>Cliente</th>
              <th>Valor</th>
              <th>Vendedor</th>
              <th>Bloqueado</th>
              <th>Voltar p/ orçam.</th>
            </tr>
          </thead>

          <tbody>
            <tr 
              :key="pedido.orcamento_id" 
              v-for="pedido in pedidos"
              v-on:click="abrirDadosOrcamento(pedido.orcamento_id)">

              <td class="w3-text-theme">{{nPadrao(pedido.orcamento_id, 0)}}</td>
              <td>{{pedido.data_fechamento}}</td>
              <td>{{pedido.nome_cliente}}</td>
              <td>{{pedido.valor_pedido}}</td>
              <td>{{pedido.nome_vendedor}}</td>

              <td v-bind:class="getClasseBloqueado(pedido.bloqueado)">
                <strong>{{simNaoString(pedido.bloqueado)}}</strong>
              </td>

              <td>
                <button
                  class="w3-button w3-col s12 w3-border"
                  v-on:click="iniciarCancelamentoPedido(pedido)">
                  <i class="fas fa-reply fa-fw w3-text-theme"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="w3-hide-large w3-hide-medium w3-container">
        <div 
          :key="pedido.orcamento_id"
          v-for="pedido in pedidos"
          class="w3-container card-item "
          @click="abrirDadosOrcamento(pedido.orcamento_id)">

          <div class="w3-col s12">
            <label>Pedido: </label>
            <strong class="w3-text-theme">{{nPadrao(pedido.orcamento_id, 0)}}</strong>
          </div>  

          <div class="w3-col s12">
            <label>Data pedido: </label>
            <strong>{{pedido.data_fechamento}}</strong>
          </div> 

          <div class="w3-col s12">
            <label>Cliente: </label>
            <strong>{{pedido.nome_cliente}}</strong>
          </div>  

          <div class="w3-col s12">
            <label>Valor: </label>
            <strong>{{pedido.valor_pedido}}</strong>
          </div>     

          <div class="w3-col s12">
            <label>Vendedor: </label>
            <strong>{{pedido.nome_vendedor}}</strong>
          </div> 

          <div class="w3-col s12">
            <label>Bloqueado: </label>
            <strong v-bind:class="getClasseBloqueado(pedido.bloqueado)">
              <span>{{simNaoString(pedido.bloqueado)}}</span>
            </strong>
          </div>

          <div class="w3-col s12 w3-center" style="font-size: 14px!important; margin-top: 8px; margin-bottom: 3px;">
            <button class="w3-button w3-border" v-on:click="iniciarCancelamentoPedido(pedido)">
              <i class="fas fa-reply fa-fw w3-text-theme"></i>
              <strong> Voltar p/ orçam.</strong>
            </button>
          </div>

        </div>
      </div>
    </div>

    <dados-orcamento
      :orcamento_dados="orcamento_detalhe"
      v-if="mostrar_modal_dados_orcamento"
      @close="mostrar_modal_dados_orcamento = false">
    </dados-orcamento>

    <modal-autorizacao
      v-if="mostrar_modal_autorizacao"
      chave="cancelar_fec_rec_ent_doc"
      descricaoAutorizacao="cancelar fechamento de pedidos com recebimento na entrega com documentos emitidos"
      @definirAutorizado="aplicarCancelamentoFechamento"
      @close="mostrar_modal_autorizacao = false">
    </modal-autorizacao>

    <div id="modalMotivoCancelamento" class="w3-modal">
      <div class="w3-modal-content w3-animate-zoom cancelameto">
        <header class="w3-container">
          <span 
            onclick="document.getElementById('modalMotivoCancelamento').style.display='none'"
            class="w3-button w3-display-topright">&times;</span>
          <h2>Motivo do cancelamento</h2>
        </header>

        <div class="w3-container">
          <br>

          <strong>Motivo: </strong>
          <textarea
            class="w3-input w3-block w3-border"
            id="observacoes-desbloqueio"
            rows="3"
            v-model="motivo_cancelamento">
          </textarea>
        </div>

        <footer class="w3-container w3-center">
          <button
            class="w3-button w3-theme"
            id="btn-confirmar-acao"
            style="margin-top: 10px; margin-bottom:10px"
            @click.prevent="cancelarFechamentoPedido()">
            <span>Confirmar</span>
          </button>

          <button
            class="w3-button w3-text-theme w3-border"
            style="margin-top: 10px; margin-bottom:10px"
            onclick="document.getElementById('modalMotivoCancelamento').style.display='none'">
            <span>Cancelar</span>
          </button>
        </footer>
        
      </div>
    </div>
  </div>
</template>

<script>
  import NavMenu from '@/components/Menu'
  import ModalAutorizacao from '@/components/Autorizar'
  import ExibirProcessando from '@/components/ExibirProcessando'
  import DadosOrcamento from '@/components/Orcamentos/DadosOrcamento'
  import Biblioteca from '@/components/Repositorio/Biblioteca.js'
  import ROrcamentoBuscarPedidosFechados from '@/components/Rest/ROrcamento/ROrcamentoBuscarPedidosFechados.js'
  import ROrcamentoCancelarFechamentoPedido from '@/components/Rest/ROrcamento/ROrcamentoCancelarFechamentoPedido.js'

  export default {
    name: 'CancelarFechamentoPedido',
    
    components: {
      NavMenu,
      DadosOrcamento,
      ModalAutorizacao,
      ExibirProcessando
    },

    data() {
      return {
        pedidos: [],
        orcamento_detalhe: {},
        pedido_selecionado: {},
        processando: false,
        cancelando_pedido: false,
        mostrar_modal_autorizacao: false,
        mostrar_modal_dados_orcamento: false,
        usuario_autorizacao_id: '',
        motivo_cancelamento: ''
      }
    },

    methods: {
      async buscarPedidos() {        
        try {
          this.pedidos = [];
          this.processando = true;

          let retorno = await ROrcamentoBuscarPedidosFechados.buscarPedidosFechados(this.axios);
          this.processando = false;
          if (retorno.houve_erro != 'N') {
            throw new Error(retorno.mensagem);
          }
          
          this.pedidos = JSON.parse(JSON.stringify(retorno.dados));
        }
        catch (error) {
          this.processando = false;
          Biblioteca.exclamar(error.message);
          return;
        }
      },

      simNaoString(sn) {
        return Biblioteca.simNaoString(sn);
      },

      abrirDadosOrcamento(orcamento_id) {
        if (this.cancelando_pedido == true) {
          return;
        }

        this.orcamento_detalhe = orcamento_id;
        this.mostrar_modal_dados_orcamento = !this.mostrar_modal_dados_orcamento;
      },

      iniciarCancelamentoPedido(pedido_selecionado) {
        this.cancelando_pedido = true;

        let msg_questionar = (
          'Deseja realmente cancelar o fechamento deste pedido ' + 
          '(ele automaticamente voltará a ser um orçamento)?'
        );

        if (pedido_selecionado.pre_pedido_id > 0) {
          msg_questionar = (
            'Deseja realmente cancelar o fechamento desse pedido ' + 
            '(ele automaticamente será excluído por ser relacionado a um pré-pedido)?'
          );
        }

        swal(
          msg_questionar,
          {
            buttons: {
              sim: 'Sim',
              nao: 'Não'
            },
          }
        )
        .then(
          (value) => {
            this.pedido_selecionado = {};
            this.usuario_autorizacao_id = 0;
            this.cancelando_pedido = false;
            this.motivo_cancelamento = '';

            if (value == 'nao') {
              return;
            }

            this.pedido_selecionado = pedido_selecionado;

            if (
              (this.pedido_selecionado.confirmado_caixa == 'S') && 
              (this.pedido_selecionado.recebimento_entrega == 'S')
            ) {
              this.mostrar_modal_autorizacao = true;
              return;
            }
            
            this.coletarMotivoCancelamento();
          }
        )
      },

      aplicarCancelamentoFechamento(usuario_id) {
        this.mostrar_modal_autorizacao = false;
        this.usuario_autorizacao_id = usuario_id;
        this.coletarMotivoCancelamento();
      },

      coletarMotivoCancelamento() {
        document.getElementById('modalMotivoCancelamento').style.display = 'block';
      },

      async cancelarFechamentoPedido() {
        try {
          if (this.motivo_cancelamento.length < 15) {
            Biblioteca.exclamar('Informe um motivo de cancelamento válido!');
            return;
          }

          document.getElementById('modalMotivoCancelamento').style.display = 'none';

          let parametros = {
            orcamento_id: this.pedido_selecionado.orcamento_id,
            motivo: this.motivo_cancelamento            
          }

          let retorno = await ROrcamentoCancelarFechamentoPedido.cancelarFechamentoPedido(
            this.axios,
            parametros
          );

          if (retorno.houve_erro != 'N') {
            throw new Error(retorno.mensagem);
          }

          Biblioteca.informar('Operação cancelada com sucesso.');
          
          this.usuario_autorizacao_id = 0;
          this.pedido_selecionado = {};
          this.motivo_cancelamento = '';
          this.cancelando_pedido = false;

          this.buscarPedidos();
        }
        catch (error) {
          Biblioteca.exclamar(error.message);
        }
      },

      verificarErro(erro) {
        this.processando = false;
        let mensagem = Biblioteca.tratamentoMensagem(erro);
        Biblioteca.exclamar(mensagem);
      },

      nPadrao(numero, casas_decimais){
        return Biblioteca.nPadrao(numero, casas_decimais);
      },

      getClasseBloqueado(bloqueado) {
        if (bloqueado == 'S') {
          return 'w3-text-theme';
        } else {
          return 'w3-text-indigo';
        }
      }
    },

    created() {
      this.buscarPedidos();
    }
  }
</script>

<style scoped>
  .titulo {
    border-bottom:1px solid #8d1007;
    font-size: 22px;
  }

  .cancelameto {
    top:120px;
    width:500px;
  }

  .card-item {
    background: white;
    border-radius: 10px;
    margin-bottom: 10px;
    padding: 5px !important;
    border: 2px solid #ccc;
    border: 1px solid #bfbfbf; 
    box-shadow: #b1b0b0 1px 2px 5px 2px;
  }

  .card-item:hover {
    border: 1px solid #bfbfbf; 
    box-shadow: #7a7a7a 1px 2px 5px 2px;
  }
</style>


// WEBPACK FOOTER //
// src/components/CancelarFechamentoPedido.vue